{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Du har overskredet grænsen for samtaler. Hacker-planen tillader kun 500 samtaler.",
      "INBOXES": "Du har overskredet grænsen for indbakker. Hacker-planen understøtter kun live chat på hjemmesiden. Andre indbakker som e-mail, WhatsApp osv. kræver et betalt abonnement.",
      "AGENTS": "Du har overskredet grænsen for agenter. Hacker-planen tillader kun 2 agenter.",
      "NON_ADMIN": "Kontakt venligst din administrator for at opgradere abonnementet og fortsætte med at bruge alle funktioner."
    },
    "TITLE": "Kontoindstillinger",
    "SUBMIT": "Opdater indstillinger",
    "BACK": "Tilbage",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Kunne ikke opdatere indstillinger, prøv igen!",
      "SUCCESS": "Kontoindstillinger blev opdateret"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Slet din konto",
      "NOTE": "Når du sletter din konto, bliver alle dine data slettet.",
      "BUTTON_TEXT": "Slet din konto",
      "CONFIRM": {
        "TITLE": "Slet konto",
        "MESSAGE": "Sletning af din konto kan ikke fortrydes. Indtast dit kontonavn nedenfor for at bekræfte, at du vil slette den permanent.",
        "BUTTON_TEXT": "Slet",
        "DISMISS": "Annuller",
        "PLACE_HOLDER": "Skriv venligst {accountName} for at bekræfte"
      },
      "SUCCESS": "Kontoen er markeret til sletning",
      "FAILURE": "Kunne ikke slette kontoen, prøv igen!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Denne konto er planlagt til sletning den {deletionDate}. Dette blev anmodet af en administrator. Du kan annullere sletningen inden denne dato.",
        "MESSAGE_INACTIVITY": "Denne konto er planlagt til sletning den {deletionDate} på grund af inaktivitet. Du kan annullere sletningen inden denne dato.",
        "CLEAR_BUTTON": "Annuller planlagt sletning"
      }
    },
    "FORM": {
      "ERROR": "Ret venligst formularfejl",
      "GENERAL_SECTION": {
        "TITLE": "Generelle indstillinger",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Konto SID",
        "NOTE": "Dette ID er påkrævet, hvis du bygger en API-baseret integration"
      },
      "NAME": {
        "LABEL": "Kontonavn",
        "PLACEHOLDER": "Dit kontonavn",
        "ERROR": "Angiv et gyldigt kontonavn"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Dit kontonavn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Indkommende E-Mail Domæne",
        "PLACEHOLDER": "Domænet, hvor du vil modtage e-mails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support E-Mail",
        "PLACEHOLDER": "Din virksomheds support e-mail",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Antal dage efter en ticket skal løses automatisk, hvis der ikke er nogen aktivitet",
        "NOTE": "Antal timers inaktivitet, hvorefter en åben samtale bliver løst automatisk.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 dag og maksimum 999 dage)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Antal dage efter hvilke en tom samtale skal løses automatisk, hvis der ikke er nogen aktivitet",
        "PLACEHOLDER": "aldrig",
        "ERROR": "Angiv en gyldig varighed for automatisk løsning af tomme samtaler (minimum 1 dag og maksimum 999 dage)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Samtale kontinuitet med e-mails er aktiveret for din konto.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Du kan modtage e-mails på dit brugerdefinerede domæne nu."
      },
      "PHONE": {
        "TITLE": "PBX-indstillinger",
        "NOTE": "Konfigurer forbindelsen til dit PBX-anlæg til telefonopkald",
        "SIP_HOST": {
          "LABEL": "SIP-domæne"
        },
        "DIALING_MODE": {
          "LABEL": "Opkaldstilstand",
          "MODES": {
            "direct": "Direkte - opkaldet foretages med det samme, når der klikkes på telefonlinket",
            "indirect": "Indirekte - telefonnummeret forberedes i telefonwidgettens indtastningsfelt"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Adgang til opkaldsoptagelser",
          "MODES": {
            "admin_only": "Kun administratorer",
            "admin_and_assigned_agent": "Administratorer og den tildelte agent",
            "inbox_members": "Alle agenter med adgang til indbakken"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-mailindstillinger",
        "NOTE": "Ændrer adfærden for e-mailindbakker"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Visningstilstand for samtalens tidsstempel",
        "MODES": {
          "both": "Oprettet og seneste aktivitet",
          "last_activity_only": "Kun seneste aktivitet",
          "last_customer_message": "Seneste kundebesked"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloker domæner med lavt omdømme"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Inkluder den oprindelige besked i svaret på e-mailen"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Løs automatisk en ny samtale"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Flyt automatisk en ny e-mailsamtale til indbakken for den robot, der behandlede kontaktens ordrer"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Udvidede etiketter - Tillad længere etiketnavne med en større popup"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Tildel automatisk samtalen til den agent, der sendte det seneste svar"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Tilstand for push-notifikationer",
        "MODES": {
          "all_inboxes": "Alle indbakker - Send notifikationer for alle kanaltyper",
          "chat_only": "Kun chat - Send kun notifikationer for kanaler, der ikke er e-mail"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Tillad, at signatur kan slås til/fra på sendte beskeder"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Vis agentens chatstatus på wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Vis fulde navne på vedhæftede filer uden afkortning"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Login med adgangskode",
        "MODES": {
          "allowed_for_all": "Tilladt for alle brugere",
          "allowed_for_agents_only": "Kun tilladt for agenter (administratorer skal bruge OAuth)",
          "password_login_disabled": "Deaktiveret - kun OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "En ny version er tilgængelig. Genindlæs for at få de seneste opdateringer.",
    "RELOAD_NOW": "Opdater nu",
    "LEARN_MORE": "Lær mere",
    "PAYMENT_PENDING": "Din betaling afventer. Opdater dine betalingsoplysninger for at fortsætte med at bruge denne software",
    "LIMITS_UPGRADE": "Din konto har overskredet forbrugsgrænserne. Opgrader dit abonnement for at fortsætte med at bruge denne software",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Tryk enter for at vælge",
      "ENTER_TO_REMOVE": "Tryk enter for at fjerne",
      "NO_OPTIONS": "Listen er tom",
      "NO_RESULT": "Ingen resultater fundet",
      "SELECT_ONE": "Vælg en",
      "SELECT": "Vælg"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifikationer",
    "MARK_ALL_DONE": "Markér Alle Udførte",
    "DELETE_TITLE": "slettet",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Ulæste Notifikationer",
      "ALL_NOTIFICATIONS": "Se alle notifikationer",
      "LOADING_UNREAD_MESSAGE": "Indlæser ulæste notifikationer...",
      "EMPTY_MESSAGE": "Du har ingen ulæste notifikationer"
    },
    "LIST": {
      "LOADING_MESSAGE": "Indlæser notifikationer...",
      "404": "Ingen Notifikationer",
      "TABLE_HEADER": [
        "Navn",
        "Telefonnummer",
        "Samtaler",
        "Sidst Kontaktet"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Ny samtale",
      "conversation_assignment": "Samtale Tildelt",
      "assigned_conversation_new_message": "Ny Besked",
      "participating_conversation_new_message": "Ny Besked",
      "conversation_mention": "Omtale",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Opdater"
    },
    "CONNECTION_LOST": {
      "TITLE": "Forbindelse mistet",
      "DESCRIPTION": "Vi kunne ikke nå serveren. Tjek din forbindelse, og prøv igen.",
      "RETRY": "Prøv igen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Søg eller hop til",
    "SECTIONS": {
      "GENERAL": "Generelt",
      "REPORTS": "Rapporter",
      "CONVERSATION": "Samtale",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Skift Modtager",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Skift Team",
      "SNOOZE_CONVERSATION": "Udsæt Samtale",
      "EXECUTE_MACRO": "Udfør Macro",
      "ADD_LABEL": "Tilføj etiket til samtalen",
      "REMOVE_LABEL": "Fjern etiket fra samtalen",
      "SETTINGS": "Indstillinger",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Gå til Konversationspanel",
      "GO_TO_CONTACTS_DASHBOARD": "Gå til Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Gå til Oversigt over rapporter",
      "GO_TO_CONVERSATION_REPORTS": "Gå til Konversationsrapporter",
      "GO_TO_AGENT_REPORTS": "Gå til Agent rapporter",
      "GO_TO_LABEL_REPORTS": "Gå til Label rapporter",
      "GO_TO_INBOX_REPORTS": "Gå til Indbakke Rapporter",
      "GO_TO_TEAM_REPORTS": "Gå til holdrapporter",
      "GO_TO_SETTINGS_AGENTS": "Gå til Agent indstillinger",
      "GO_TO_SETTINGS_TEAMS": "Gå til teamindstillinger",
      "GO_TO_SETTINGS_INBOXES": "Gå til Indbakkeindstillinger",
      "GO_TO_SETTINGS_LABELS": "Gå til Label indstillinger",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Gå til Indstillinger for scannede svar",
      "GO_TO_SETTINGS_APPLICATIONS": "Gå til programindstillinger",
      "GO_TO_SETTINGS_ACCOUNT": "Gå til kontoindstillinger",
      "GO_TO_SETTINGS_PROFILE": "Gå til profilindstillinger",
      "GO_TO_NOTIFICATIONS": "Gå til Notifikationer",
      "ADD_LABELS_TO_CONVERSATION": "Tilføj etiket til samtalen",
      "ASSIGN_AN_AGENT": "Tildel en agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Tildel et team",
      "EXECUTE_A_MACRO": "Udfør en macro",
      "MUTE_CONVERSATION": "Gør samtale lydløs",
      "UNMUTE_CONVERSATION": "Fjern samtale",
      "REMOVE_LABEL_FROM_CONVERSATION": "Fjern etiket fra samtalen",
      "REOPEN_CONVERSATION": "Genåbn samtale",
      "RESOLVE_CONVERSATION": "Løs samtale",
      "SEND_TRANSCRIPT": "Send en e-mail udskrift",
      "SNOOZE_CONVERSATION": "Udsæt Samtale",
      "UNTIL_NEXT_REPLY": "Indtil næste svar",
      "UNTIL_NEXT_WEEK": "Indtil næste uge",
      "UNTIL_TOMORROW": "Indtil i morgen",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Indlæser Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "klik her"
  }
}
